import axios from 'axios';

const apiUrl = window._env_?.REACT_APP_API_URL || 'https://app.mylocaleventrentals.com/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return { 'x-auth-token': token };
};

export const listExtensions = () => axios.get(`${apiUrl}/v1/extensions`, { headers: getHeaders() });

export const getExtensionSettings = (name) =>
  axios.get(`${apiUrl}/v1/extensions/${name}/settings`, { headers: getHeaders() });

export const updateExtensionSettings = (name, payload) =>
  axios.put(`${apiUrl}/v1/extensions/${name}/settings`, payload, { headers: getHeaders() });

export const listSmsTemplates = () =>
  axios.get(`${apiUrl}/v1/extensions/twilio-sms/templates`, { headers: getHeaders() });

export const createSmsTemplate = (payload) =>
  axios.post(`${apiUrl}/v1/extensions/twilio-sms/templates`, payload, { headers: getHeaders() });

export const updateSmsTemplate = (id, payload) =>
  axios.put(`${apiUrl}/v1/extensions/twilio-sms/templates/${id}`, payload, { headers: getHeaders() });

export const deleteSmsTemplate = (id) =>
  axios.delete(`${apiUrl}/v1/extensions/twilio-sms/templates/${id}`, { headers: getHeaders() });

export const listSmsMessages = () =>
  axios.get(`${apiUrl}/v1/extensions/twilio-sms/messages`, { headers: getHeaders() });

export const getSmsMessage = (id) =>
  axios.get(`${apiUrl}/v1/extensions/twilio-sms/messages/${id}`, { headers: getHeaders() });

export const sendSmsMessage = (payload) =>
  axios.post(`${apiUrl}/v1/extensions/twilio-sms/messages/send`, payload, { headers: getHeaders() });

export const retrySmsMessage = (id) =>
  axios.post(`${apiUrl}/v1/extensions/twilio-sms/messages/${id}/retry`, {}, { headers: getHeaders() });

// Conversations
export const listSmsConversations = (params = {}) =>
  axios.get(`${apiUrl}/v1/extensions/twilio-sms/conversations`, { headers: getHeaders(), params });

export const getSmsConversationMessages = (conversationId, params = {}) =>
  axios.get(`${apiUrl}/v1/extensions/twilio-sms/conversations/${conversationId}/messages`, { headers: getHeaders(), params });

export const sendSmsFromConversation = (conversationId, payload) =>
  axios.post(`${apiUrl}/v1/extensions/twilio-sms/messages/send`, { conversationId, ...payload }, { headers: getHeaders() });
